import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a40a38a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "***Note: ***"),
  /*#__PURE__*/_createTextVNode(" all calculations are based on a $10,000 estate.")
], -1))
const _hoisted_3 = ["onClick"]

import Self from "@/bll/models/Self.mjs";
import { ref } from "vue";
import Tests from "@/bll/testing/test_provider.mjs";

interface Props {
  onTestClickCallback: (self: Self) => void;
  closeDialog: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowTestsComponent',
  props: {
    onTestClickCallback: { type: Function },
    closeDialog: { type: Function }
  },
  setup(__props: any) {

const props = __props;



// eslint-disable-next-line @typescript-eslint/ban-types
function handleTestClick(test: Function) {
  props.onTestClickCallback(test());
}

function handleCloseClick() {
  props.closeDialog();
}

const container = ref();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "show-tests-component",
    ref_key: "container",
    ref: container
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        id: "close-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleCloseClick()))
      }, "X"),
      _hoisted_2,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Tests), (test) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "test-entry",
            key: test.name
          }, [
            _createElementVNode("a", {
              href: "#",
              onClick: ($event: any) => (handleTestClick(test))
            }, _toDisplayString(test.name), 9, _hoisted_3)
          ]))
        }), 128))
      ])
    ])
  ], 512))
}
}

})